export default [
	{
		path: '/view/japan-expo-paris-2024',
		lazy: async () => {
			const Module = await import('../../pages/JTS/JtsPage');
			return { Component: Module.default };
		},
	},
];
